import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme.css';
import './App.css';
import VideoConverter from './components/VideoConverter';
import { Container, Row, Col } from 'react-bootstrap';

function App() {
  return (
    <div className="App d-flex flex-column min-vh-100">
      {/* Animated Background */}
      <div className="animated-bg">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
      </div>

      <div className="app-content d-flex flex-column min-vh-100">
        <header className="py-4 text-center" style={{
          background: 'linear-gradient(135deg, rgba(91, 141, 239, 0.15) 0%, rgba(167, 139, 250, 0.1) 100%)',
          borderBottom: '1px solid rgba(91, 141, 239, 0.15)',
          backdropFilter: 'blur(20px)',
          color: '#e2e8f0'
        }}>
          <Container>
            <h1 className="mb-0" style={{
              fontSize: '1.75rem',
              fontWeight: '600',
              background: 'linear-gradient(135deg, #5b8def, #38bdf8, #a78bfa)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Client-side HEVC(H.265), H.264, WebM(VP9), AVI and MP3 Video Converter
            </h1>
          </Container>
        </header>
        
        <Container className="flex-grow-1">
          <VideoConverter />
        </Container>
        
        <footer className="py-3 mt-auto" style={{
          background: 'rgba(22, 25, 34, 0.8)',
          borderTop: '1px solid rgba(91, 141, 239, 0.1)',
          backdropFilter: 'blur(20px)'
        }}>
          <Container>
            <Row>
              <Col className="text-center d-flex flex-column align-items-center gap-1">
                <p className="text-body-secondary mb-0 small">
                Client-side HEVC(H.265), H.264, WebM(VP9), AVI and MP3 Video Converter © Li Fan 2025
                </p>
                <a 
                  href="https://www.paypal.com/paypalme/lifan" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-decoration-none small"
                  style={{
                    color: '#5b8def',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.textDecoration = 'underline';
                    e.target.style.color = '#38bdf8';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.textDecoration = 'none';
                    e.target.style.color = '#5b8def';
                  }}
                >
                  🍺 Buy Me A Beer
                </a>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </div>
  );
}

export default App;
